import { InputBaseCSS, InputMessageCSS, InputErrorMessageCSS, InputLabelCSS, InputRequiredAsteriskCSS, InputWrapperCSS, } from '../common/index.js';
import styled, { css } from 'styled-components';
import { Flex } from '../Flex/index.js';
export const InputLabel = styled.label `
  ${InputLabelCSS}
`;
export const ErrorMessage = styled.label `
  ${InputErrorMessageCSS}
`;
export const InputMessage = styled.label `
  ${InputMessageCSS};

  ${({ isMaxLimitReached }) => {
    if (isMaxLimitReached)
        return css `
        color: ${({ theme }) => theme.colors.ErrorDefault};
      `;
    return css ``;
}}
`;
export const RequiredAsterisk = styled(InputLabel) `
  ${InputRequiredAsteriskCSS}
`;
export const BKJPillTextAreaWrapper = styled.label `
  ${InputWrapperCSS};
  display: flex;
  flex-direction: column;
`;
export const TextAreaWrapper = styled.div `
  ${InputBaseCSS};
  border: 1px solid ${({ theme }) => theme.colors.Grey6};
  padding: 0;
  height: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  overflow-y: overlay;
  min-height: 195px;
  height: 195px;
  max-height: 195px;
  position: relative;
`;
export const Input = styled.textarea `
  font-size: 14px;
  padding: 0px 12px;
  border: none;
  outline: none;
  width: 100%;
  line-height: 24px;
  resize: none;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  ${({ margin }) => margin &&
    css `
      margin: ${margin};
    `};
  ${({ theme }) => theme.fonts.PoppinsTextMedium};
  ${({ error }) => error &&
    css `
      color: ${({ theme }) => theme.colors.ErrorDefault};
    `}
`;
export const BKJPillRowWrapper = styled(Flex) `
  padding: 0px 8px;
  padding-bottom: 4px;
  &:last-child {
    padding-bottom: 8px;
  }
`;
//# sourceMappingURL=BKJPillTextArea.styled.js.map